import axios from 'axios';
import toast from 'react-hot-toast';

const authString = localStorage.getItem('auth');
const authData = authString && authString !== "undefined" ? JSON.parse(authString) : null;

let baseURL;
if (window.location.hostname === 'dashboard.flexdeals.com.ng') {
  baseURL = 'https://admin.flexdeals.com.ng/api/v1';
} else {
  // This will be used for localhost and the staging IP address
  baseURL = 'https://staging.flexdeals.com.ng/api/v1';
}

const instance = axios.create({
  baseURL,
});
const notifyError = (err) => toast.error(err);

instance.interceptors.request.use(
  (config) => {
    const dataString = localStorage.getItem('auth');
    const data = dataString && dataString !== "undefined" ? JSON.parse(dataString) : null;
    if (data && data.token) {
      config.headers['x-auth-token'] = data.token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.statusText === 'Unauthorized'
    ) {
      notifyError('SESSION TIMEOUT !');
      let href = authData && authData.merchant_type ? '/login' : '/admin';
      localStorage.clear();
      window.location.href = href;

      return;
    }
    return Promise.reject(error);
  }
);

export default instance;
